import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { articleMembershipOptions } from '@/module/Nomen/ArticleMembership/model/ArticleMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type ArticleMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ArticleMembershipSelectControl<T extends FieldValues>(props: ArticleMembershipSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(articleMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
